
import React, { Component } from 'react';
import campaignData from './data.json';

export default class CampaignList extends Component {
  state = {
    campaigns: [],
    showModal: false,
    selectedDays: [],
    selectedTitle: ''
  };

  componentDidMount() {
    const campaigns = campaignData.campaign.map((camp) => {
      const daily = this.groupByDate(camp.orders);

      const counters = {
        waiting: 0,
        inDelivery: 0,
        notWanted: 0,
        newOrder: 0,
        canceled: 0,
        returned: 0,
        net: 0
      };

      camp.orders.forEach(({ order }) => {
        switch (order.status) {
          case 0: counters.waiting++; break;
          case 1: counters.inDelivery++; break;
          case -1: counters.notWanted++; break;
          case -2: counters.newOrder++; break;
          case 2: counters.canceled++; break;
          case 4: counters.returned++; break;
          default: break;
        }
        counters.net += Number(order.cost || 0);
      });

      return {
        id: camp.id,
        productName: camp.item.name,
        startDate: new Date(camp.start_date).toLocaleDateString(),
        lastUpdate: new Date(camp.updatedAt).toLocaleString(),
        totalOrders: camp.orders.length,
        conversions: counters.inDelivery,
        budget: camp.bg,
        net: counters.net.toFixed(2),
        remaining: camp.item.count,
        ...counters,
        dailyStats: daily
      };
    });

    this.setState({ campaigns });
  }

  groupByDate = (orders) => {
    const dailyMap = {};

    orders.forEach(({ order }) => {
      const date = new Date(order.createdAt).toLocaleDateString();
      if (!dailyMap[date]) {
        dailyMap[date] = {
          newOrder: 0,
          waiting: 0,
          inDelivery: 0,
          notWanted: 0,
          canceled: 0,
          returned: 0,
          totalOrders: 0,
          net: 0
        };
      }

      const group = dailyMap[date];
      switch (order.status) {
        case 0: group.waiting++; break;
        case 1: group.inDelivery++; break;
        case -1: group.notWanted++; break;
        case -2: group.newOrder++; break;
        case 2: group.canceled++; break;
        case 4: group.returned++; break;
        default: break;
      }

      group.net += Number(order.cost || 0);
      group.totalOrders++;
    });

    return Object.entries(dailyMap)
      .map(([date, data]) => ({ date, ...data }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  };

  openModal = (days, title) => {
    this.setState({ showModal: true, selectedDays: days, selectedTitle: title });
  };

  closeModal = () => {
    this.setState({ showModal: false, selectedDays: [], selectedTitle: '' });
  };

  render() {
    const { campaigns, showModal, selectedDays, selectedTitle } = this.state;

    const containerStyle = {
      padding: 20,
      fontFamily: 'Cairo, sans-serif',
      direction: 'rtl',
      display: 'flex',
      justifyContent: 'center'
    };

    const innerStyle = {
      width: '100%',
      maxWidth: '600px'
    };

    const cardStyle = {
      border: '1px solid #ddd',
      borderRadius: 10,
      padding: 20,
      marginBottom: 30,
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
    };

    const tableStyle = {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: 15,
      textAlign: 'center'
    };

    const thStyle = {
      backgroundColor: '#f5f5f5',
      padding: '8px',
      border: '1px solid #ccc'
    };

    const tdStyle = {
      padding: '8px',
      border: '1px solid #ddd'
    };

    const buttonStyle = {
      marginTop: 15,
      padding: '10px 20px',
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      borderRadius: 6,
      cursor: 'pointer'
    };

    if (campaigns.length === 0) return <div>جاري تحميل البيانات...</div>;

    return (
      <div style={containerStyle}>
        <div style={innerStyle}>
          <h2 style={{ textAlign: 'center' }}>📊 تقرير الحملات الإعلانية</h2>

          {campaigns.map((camp, idx) => {
            const recentDays = camp.dailyStats.slice(0, 3);
            return (
              <div key={idx} style={cardStyle}>
                <h3 style={{ color: '#007bff' }}>📦 المنتج: {camp.productName}</h3>
                <p><strong>رقم الحملة:</strong> {camp.id} | <strong>تاريخ البداية:</strong> {camp.startDate}</p>
                <p><strong>الطلبات:</strong> {camp.totalOrders} | <strong>التحويلات:</strong> {camp.conversions} | <strong>الصافي:</strong> {camp.net} | <strong>المتبقي:</strong> {camp.remaining}</p>

                <div style={{ overflowX: 'auto' }}>
                  <table style={tableStyle}>
                    <thead>
                      <tr>
                        <th style={thStyle}>انتظار</th>
                        <th style={thStyle}>قيد التوصيل</th>
                        <th style={thStyle}>لا يريد</th>
                        <th style={thStyle}>جديد</th>
                        <th style={thStyle}>إلغاء</th>
                        <th style={thStyle}>راجع</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={tdStyle}>{camp.waiting}</td>
                        <td style={tdStyle}>{camp.inDelivery}</td>
                        <td style={tdStyle}>{camp.notWanted}</td>
                        <td style={tdStyle}>{camp.newOrder}</td>
                        <td style={tdStyle}>{camp.canceled}</td>
                        <td style={tdStyle}>{camp.returned}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <h4 style={{ marginTop: 20 }}>📅 تقارير آخر 3 أيام</h4>
                <div style={{ overflowX: 'auto' }}>
                  <table style={tableStyle}>
                    <thead>
                      <tr>
                        <th style={thStyle}>التاريخ</th>
                        <th style={thStyle}>جديد</th>
                        <th style={thStyle}>انتظار</th>
                        <th style={thStyle}>قيد التوصيل</th>
                        <th style={thStyle}>لا يريد</th>
                        <th style={thStyle}>إلغاء</th>
                        <th style={thStyle}>راجع</th>
                        <th style={thStyle}>مجموع الطلبات</th>
                        <th style={thStyle}>الصافي</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recentDays.map((d, i) => (
                        <tr key={i}>
                          <td style={tdStyle}>{d.date}</td>
                          <td style={tdStyle}>{d.newOrder}</td>
                          <td style={tdStyle}>{d.waiting}</td>
                          <td style={tdStyle}>{d.inDelivery}</td>
                          <td style={tdStyle}>{d.notWanted}</td>
                          <td style={tdStyle}>{d.canceled}</td>
                          <td style={tdStyle}>{d.returned}</td>
                          <td style={tdStyle}>{d.totalOrders}</td>
                          <td style={tdStyle}>{d.net.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <button style={buttonStyle} onClick={() => this.openModal(camp.dailyStats, camp.productName)}>
                  📅 عرض كامل التقرير اليومي
                </button>
              </div>
            );
          })}

          {showModal && (
            <div style={{
              position: 'fixed',
              top: 0, left: 0,
              width: '100%', height: '100%',
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              zIndex: 999
            }}>
              <div style={{
                background: '#fff',
                padding: 20,
                borderRadius: 10,
                maxHeight: '80vh',
                overflowY: 'auto',
                width: '95%',
                maxWidth: '600px',
                direction: 'rtl'
              }}>
                <h3>📅 التقرير الكامل: {selectedTitle}</h3>
                <div style={{ overflowX: 'auto' }}>
                  <table style={tableStyle}>
                    <thead>
                      <tr>
                        <th style={thStyle}>التاريخ</th>
                        <th style={thStyle}>جديد</th>
                        <th style={thStyle}>انتظار</th>
                        <th style={thStyle}>قيد التوصيل</th>
                        <th style={thStyle}>لا يريد</th>
                        <th style={thStyle}>إلغاء</th>
                        <th style={thStyle}>راجع</th>
                        <th style={thStyle}>الطلبات</th>
                        <th style={thStyle}>الصافي</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedDays.map((d, i) => (
                        <tr key={i}>
                          <td style={tdStyle}>{d.date}</td>
                          <td style={tdStyle}>{d.newOrder}</td>
                          <td style={tdStyle}>{d.waiting}</td>
                          <td style={tdStyle}>{d.inDelivery}</td>
                          <td style={tdStyle}>{d.notWanted}</td>
                          <td style={tdStyle}>{d.canceled}</td>
                          <td style={tdStyle}>{d.returned}</td>
                          <td style={tdStyle}>{d.totalOrders}</td>
                          <td style={tdStyle}>{d.net.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <button style={{ ...buttonStyle, backgroundColor: '#dc3545' }} onClick={this.closeModal}>
                  ❌ إغلاق
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
